'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";
import PropTypes from 'prop-types';

import { FaBan } from "react-icons/fa";

import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Form from "react-bootstrap/Form";

import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import appStore from "@uw-it-sis/lib-react/lib/AppStore";

import addEditNoteFormStore from './AddEditNoteFormStore';
import {PLAN_ITEM_NOTE_LIMIT} from "./Constants";

/**
 * Allows users to add or edit a note
 */

class AddEditNoteForm extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.store = addEditNoteFormStore;

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
    }

    componentDidMount() {
        this.store.mount(this.props.courseCode, this.props.planItemId, this.props.termId, this.props.note, this.props.credit);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ( this.store.state === States.done ) {
            // Auto close the modal when a plan item successfully added
            if ( this.store.isSuccessful() ) {
                this.handleCancelClick();
            }
            /*
            // This code was causing REGXP-3059, but not sure what its purpose is and why it was added.
            // Set the focus inside textarea
            this.note.focus();
            // Set cursor to the end of the current note
            this.note.setSelectionRange(this.note.value.length, this.note.value.length);
            */
        }
    }

    componentWillUnmount() {
        this.store.unmount();
    }

    /**
     * Callback to the parent component when the cancel link is clicked.
     */
    handleCancelClick() {
        this.props.onCancel();
    }

    /**
     * Handle input widget changes.
     */
    onChange(e) {
        let property = e.target.name;
        let value = e.target.value;
        if ( value === null || value === undefined ) {
            value = "";
        }
        this.store.updateFormData(property, value);
    }

    /**
     * Handle form submit.
     */
    onSubmit(e) {
        e.preventDefault();  //  Prevent POST and reload.
        this.store.updateNote();
    }

    render()  {
        let note = this.store.getFormData().note ? this.store.getFormData().note : "";
        let title = appStore.isAdviser() ? "Describe recommendation reason" : "Enter a short note for this course";
        let label = appStore.isAdviser() ? "Recommendation reason" : "Notes (Optional)";
        // Build messaging for if there was a failure to move
        let failureMessage;
        if ( this.store.updateFailedMessage && "" !== this.store.updateFailedMessage ) {
            failureMessage =
                <Alert variant="danger" className="mb-0 mt-3 d-flex align-items-start">
                    <FaBan className="me-2 mt-1" aria-hidden={true} />
                    <span>{this.store.updateFailedMessage}</span>
                </Alert>
        }

        const noteMaxLength = PLAN_ITEM_NOTE_LIMIT;
        let noteRemainLength = Math.max(0, (noteMaxLength - note.length));

        return (
            <Form onSubmit={this.onSubmit}>
                <div className="fw-bolder lead mb-3">
                    {title}
                </div>
                <Form.Group controlId="update-note">
                    <Form.Label>
                        {label}
                    </Form.Label>
                    <Form.Control as="textarea"
                                  rows={5}
                                  size="sm"
                                  name="note"
                                  maxLength={noteMaxLength}
                                  value={note}
                                  ref={(input) => { this.note = input; }}
                                  onChange={this.onChange} />
                    <Form.Text className="d-flex justify-content-end">
                        <strong>{noteRemainLength}</strong>&nbsp;
                        <span>characters remaining</span>
                    </Form.Text>
                </Form.Group>
                <ButtonToolbar className="justify-content-end mt-3">
                    <Button id="update-note-submit"
                            type="submit"
                            variant="primary"
                            disabled={this.store.state === States.initial || this.store.state === States.pending}>
                        Update
                    </Button>
                    <Button id="update-note-cancel" className="btn-secondary" onClick={this.handleCancelClick} type="reset">
                        Cancel
                    </Button>
                </ButtonToolbar>
                <div role="alert" aria-live="assertive" aria-atomic="true">
                    {failureMessage}
                </div>
            </Form>
        );
    }
}
AddEditNoteForm.propTypes = {
    planItemId: PropTypes.string.isRequired,
    termId: PropTypes.string.isRequired,
    note: PropTypes.string,
    credit: PropTypes.string.isRequired,
    courseCode: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired
};
export default observer(AddEditNoteForm);